export const getAskRecordSourceEntryId = (source = {}) => String(source?.id || '').trim();

export const getAskRecordSourceDate = (source = {}) => {
  const value = source?.date || source?.timestamp || source?.createdAt || null;
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const requestTimelineEntryFocus = (setFocusEntryId, entryId) => {
  if (typeof setFocusEntryId !== 'function' || !entryId) return;

  setFocusEntryId(null);
  window.setTimeout(() => {
    setFocusEntryId(entryId);
  }, 0);
};
